module.exports = __webpack_public_path__ + "img/48.822c1f0b.jpg";